module.exports = __webpack_public_path__ + "static/img/banner_solutions_customization.e5feb68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/banner_solutions_customization.png
// module id = vciy
// module chunks = 10